export default __webpack_public_path__ + "static/media/cowry-asa-3x.ee533b0d.png";